// extracted by mini-css-extract-plugin
export default {"button":"MyButton_button__8881t","buttonText":"MyButton_buttonText__v-MwZ"};